module.exports = __webpack_public_path__ + "img/circle-error.0ed10588.svg";